import { BrowserHistory } from 'history';
import { i18n as i18next } from 'i18next';
import { getI18n } from 'react-i18next';

import BaseComponent, { getClassName } from 'xgimi-ui/BaseComponent';

import { getHistory } from '@/router/history';
import { getLanguage } from '@/languages';
import SensorsName from '@/constants/SensorsName';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const sensors = require('sa-sdk-javascript');

// 构造配置
export interface Option {
  // 页面标题
  title?: string;
  // 页面标题多语言key
  titleKey?: string;
  // 多语言key
  languageKey?: string;
}

/**
 * 基础组件
 */
export default class <P = Record<string, any>, S = Record<string, any>, SS = any> extends BaseComponent<P, S, SS> {
  // 多语言key
  private readonly languageKey: string = '';

  constructor(props: P, option: Option = {}) {
    super(props);
    if (option.languageKey) {
      this.languageKey = option.languageKey;
      // 监听多语言切换
      this.i18n.on('languageChanged', this.onLanguageChanged);
    }

    if (option.title) {
      window.document.title = option.title;
    }
    else if (option.titleKey) {
      window.document.title = this.t(option.titleKey);
    }
  }

  componentWillUnmount() {
    if (this.languageKey) {
      this.i18n.off('languageChanged', this.onLanguageChanged);
    }
  }

  /**
   * 设置标题
   * @param title
   */
  protected setTitle = (title: string) => {
    window.document.title = title;
  };

  /**
   * 多语言切换
   */
  private onLanguageChanged = () => {
    this.forceUpdate();
  };

  /**
   * 获取i18n (切换语言: getI18n().changeLanguage('lang'))
   */
  protected get i18n(): i18next {
    return getI18n();
  }

  /**
   * 语言文案
   * @param key 模块key
   * @param name 当为空时将以key为name
   * @param values 格式化值 当为空时将以name为values
   */
  protected t = (key: string, name?: string | Record<string, any>, values?: Record<string, any>): string => {
    let i18Key: string = key;
    if (typeof name === 'string') {
      i18Key = name;
    }
    else {
      if (typeof name === 'object') {
        values = name;
      }
      key = this.languageKey;
    }
    return getLanguage()(key ? `${key}.${i18Key}` : i18Key, values);
  };

  /**
   * history
   */
  protected get history(): BrowserHistory {
    return getHistory();
  }

  /**
   * 埋点
   * @param name 埋点名
   * @param data 数据
   */
  protected sensorsTrack = (name: SensorsName, data?: Record<string, any>): void => {
    sensors.track('$WebClick', {
      type: name,
      ...data,
    });
  };
}

export { getClassName };
